import { api } from "."

export default async function sendVisitorInfo(payload) {
	const url = "/webpage"
	await api.post({ url, data: payload })
}
